import type {Page, Result, UseCase} from 'framework';
import type {AssistantError} from '../../domain/errors';
import type {Conversation} from '../../domain/conversation';
import type {AssistantRepository, ListConversationsInput} from '../ports/assistant.repository';

export class ListConversations implements UseCase<[ListConversationsInput], Page<Conversation>> {
  constructor(private readonly repository: AssistantRepository) {}

  execute(input: ListConversationsInput): Promise<Result<Page<Conversation>, AssistantError>> {
    return this.repository.list(input);
  }
}
